import {
  IDefaultSchema,
  DatahubEntity,
  ErrorAction,
  IErrorSchema,
  DATA_VERSION,
  CaptureEventData,
  CaptureEvent,
} from 'src/interfaces/Datahub';
import ApplicationService from 'src/services/ApplicationService';

type ErrorData = {
  code: string;
  platform: string;
}

class Error {
  defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  measure(captureEvent: CaptureEvent<ErrorAction>, errorData: ErrorData) {
    const errorCode = `${errorData.platform}-${errorData.code}`;
    const currentTime = ApplicationService.player?.currentTime || 0;

    const event: IErrorSchema = {
      ...this.defaultData,
      code: errorCode,
      time: Math.floor(currentTime)
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['1.0'],
    };

    captureEvent(DatahubEntity.ERROR, ErrorAction.MEASURE, data);
  }
}
export default Error;